var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "control-action"
  }, [!_vm.isGroupItem ? [_vm.currentControlItem && _vm.currentControlItem.association && _vm.currentControlItem.association.association && _vm.currentControlItem.association.association.length > 0 ? _c("a-button", {
    staticClass: "title_but related",
    attrs: {
      type: "info"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("relationClick", _vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("已关联")) + " ")]) : _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("relationClick", _vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("关联")) + " ")])] : _vm._e(), _vm.canMoveUp(_vm.currentControlIndex) ? _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info",
      disabled: _vm.currentControlIndex === 0
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.moveUp(_vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上移")))]) : _vm._e(), _vm.canMoveDown(_vm.currentControlIndex) ? _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info",
      disabled: _vm.currentControlIndex === _vm.formDataArray.length - 1
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.moveDown(_vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("下移")) + " ")]) : _vm._e(), _vm.currentControlItem.partsType !== "sign" ? _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.editControl.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("编辑")) + " ")]) : _vm._e(), _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.deleteControl(_vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("删除")))]), !_vm.isGroupControl ? _c("a-button", {
    staticClass: "title_but",
    attrs: {
      type: "info"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.copyControl(_vm.currentControlIndex);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("复制宏")))]) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };